import { produce } from 'immer';

import { UpdateImportExportWizardMode } from '../../actions/importExportWizard/updateImportExportWizardMode';
import { ImportExportWizardState } from '../../typings/importExportWizard';

export function updateImportExportWizardMode(
    state: ImportExportWizardState,
    action: UpdateImportExportWizardMode
): ImportExportWizardState {
    return produce(state, draft => {
        draft.wizardMode = action.mode;
    });
}
